<!--
2023-03-28 Matt 按周下注流水返利活动
-->
<template>
  <div class="betActivityWeeklyPage">
    <div class="nav-wrapper">
      <TopBack />
      <img
        class="top-image"
        :alt="$route.params.category"
        src="https://s3.ap-northeast-1.amazonaws.com/media.web.pgebet.com/betting_activity/betting_activity_weekly_banner_20230330.jpg"
        v-if="$route.params.category === 'SportsGames'"
      >
      <img
        class="top-image"
        :alt="$route.params.category"
        src="https://s3.ap-northeast-1.amazonaws.com/media.web.pgebet.com/betting_activity/betting_activity_weekly_slot_banner_20230510.png"
        v-else-if="$route.params.category === 'SlotGames'"
      >
      <img
        class="top-image"
        :alt="$route.params.category"
        src="https://s3.ap-northeast-1.amazonaws.com/media.web.pgebet.com/betting_activity/betting_activity_weekly_live_banner_20230510.png"
        v-else-if="$route.params.category === 'LiveCasino'"
      >
      <div class="nav">
        <div class="nav-item" :class="{active: activeTab==='cashReward'}" @click="activeTab = 'cashReward'">
          {{$t('lang.betActivityWeekly.cashReward')}}
        </div>
        <div class="nav-item" :class="{active: activeTab==='rules'}" @click="activeTab = 'rules'">
          {{$t('lang.betActivityWeekly.rules')}}
        </div>
        <div class="nav-item" :class="{active: activeTab==='history'}" @click="activeTab = 'history'">
          {{$t('lang.betActivityWeekly.history')}}
        </div>
      </div>
    </div>

    <div class="tab cashReward" v-show="activeTab==='cashReward'">
      <div class="row">
        <div class="title">
          {{$t('lang.betActivityWeekly.BetThisWeek')}}
        </div>
        <div class="vertical-bar">
          <span>|</span>
        </div>
        <div class="description">
          ₹{{ liveMemo.today ? liveMemo.today.TotalAmount : 0 }}
        </div>
      </div>
      <div class="row estimated">
        <div class="title">
          {{$t('lang.betActivityWeekly.estimatedReward')}}
          <span>
            {{$t('lang.betActivityWeekly.distributingNextWeek')}}
          </span>
        </div>
        <div class="vertical-bar">
          <span>|</span>
        </div>
        <div class="description">
          ₹{{ liveMemo.thisWeek ? liveMemo.thisWeek.Reward : 0 }}
        </div>
      </div>
      <div class="row">
        <div class="title">
          {{$t('lang.betActivityWeekly.RewardOfLastWeek')}}
        </div>
        <div class="vertical-bar">
          <span>|</span>
        </div>
        <div class="description">
          ₹{{ liveMemo.lastWeek ? liveMemo.lastWeek.Reward : 0 }}
        </div>
      </div>
      <div class="play-btn" @click="onJoinNow()" v-if="historyList.length === 0">
        <span>{{$t('lang.betActivityWeekly.joinNow')}}</span>
      </div>
      <div class="play-btn" @click="onPlay()" v-else>
        <span>{{$t('lang.betActivityWeekly.play')}}</span>
      </div>
    </div>

    <div class="tab rules" v-show="activeTab==='rules'" v-html="rulesHtml">
    </div>

    <div class="tab" v-show="activeTab==='history'">
      <div class="history-item">
        <div class="history-content" style="background: none">
          <div class="date">
            <span>
              {{$t('lang.betActivityWeekly.week')}}
            </span>
          </div>

          <div class="splitter"></div>

          <div class="betting-amount">
            <span style="margin: 0 auto">
              {{$t('lang.betActivityWeekly.bettingAmount')}}
            </span>
          </div>

          <div class="splitter"></div>

          <div class="reward">
            <span style="margin: 0 auto">
              {{$t('lang.betActivityWeekly.reward')}}
            </span>
          </div>
        </div>
      </div>
      <Loadmore
        :bottomPullText="$t('lang.loadingStatus.pullToLoad')"
        :bottomDropText="$t('lang.loadingStatus.releaseToLoad')"
        :bottomLoadingText="$t('lang.loadingStatus.loading')"
        :auto-fill="true"
        :bottom-method="getHistoryList"
        :bottom-all-loaded="hasLoadAll"
        ref="loadmore">
        <div class="historyList">
          <div v-for="(item, index) in historyList" :key="index" class="history-item">
            <div class="history-content">
              <div class="date">
                <span>{{index + 1}}</span>
              </div>

              <div class="splitter"></div>

              <div class="betting-amount">
                <span>{{item.TotalAmount}}</span>
              </div>

              <div class="splitter"></div>

              <div class="reward">
                <span>{{item.Reward}}</span>
              </div>
            </div>
          </div>
          <div v-if="historyList && historyList.length === 0" class="no-data-available">
            {{$t('lang.betActivityWeekly.noDataAvailable')}}
          </div>
        </div>
      </Loadmore>
    </div>
  </div>
</template>

<script>
import {Loadmore, MessageBox} from 'mint-ui'
import request from '@/service'
import axios from 'axios'

import TopBack from '@/components/TopBack/index'

export default {
  name: 'betActivityWeekly',
  data () {
    return {
      activeTab: 'cashReward',
      accountInfo: {},
      userInfo: JSON.parse(localStorage.getItem('userInfo')) || {},
      historyList: [],
      liveMemo: {
        thisWeek: {},
        lastWeek: {}
      },
      firstLoad: false,
      hasLoadAll: false,
      rulesHtml: ''
    }
  },
  components: {
    TopBack,
    Loadmore
  },
  watch: {},
  mounted () {
    this.loadData()
    this.getCurrentActivity()
    this.getHistoryList()
    this.getLiveMemo()
  },
  methods: {
    close () {},
    loadData: function () {
      const that = this
      let internation = ''
      if (localStorage.getItem('locale') === 'IN') {
        internation = 'IN'
      } else {
        internation = 'INT'
      }
      const url = location.origin + '/static/startupPopup-' + internation + '.json'
      axios.get(url).then(res => {
        if (res.data != null) {
          let languagePre = this.$store.state.locale
          languagePre = languagePre === 'EN' ? '' : '-' + languagePre
          const htmlFileURL = location.origin + '/static/promotionRules/BetActivityWeekly-' + that.$route.params.category + '-' + this.$store.state.internation + languagePre + '.html'
          axios.get(htmlFileURL).then(res => {
            if (res.data != null) {
              that.rulesHtml = res.data
            }
          })
        }
      })
    },
    getCurrentActivity () {
      const internation = this.$store.state.internation || 'IN'
      const category = this.$route.params.category
      request('get', `/innovation/activity-weekly/bet-current?internation=${internation}&category=${category}`)
        .then(activity => {
          const startAt = new Date(activity.StartAt)
          const endAt = new Date(activity.EndAt)
          const now = new Date()

          if (now < startAt) {
            MessageBox.confirm(
              this.$t('lang.betActivityWeekly.activityNotStartYetMessageContent'),
              this.$t('lang.betActivityWeekly.activityNotStartYetMessageTitle'),
              {
                closeOnClickModal: true,
                showCancelButton: false,
                confirmButtonText: this.$t('lang.betActivityWeekly.confirmButtonText')
              })
          } else if (now > endAt) {
            MessageBox.confirm(
              this.$t('lang.betActivityWeekly.activityEndedMessageContent'),
              this.$t('lang.betActivityWeekly.activityEndedMessageTitle'),
              {
                closeOnClickModal: true,
                showCancelButton: false,
                confirmButtonText: this.$t('lang.betActivityWeekly.confirmButtonText')
              })
          }
        })
    },
    getLiveMemo () {
      const category = this.$route.params.category
      request('get', `/innovation/activity-weekly/bet-memo?userId=${this.userInfo.UserId}&category=${category}`)
        .then(liveMemo => {
          this.liveMemo = liveMemo
        })
    },
    getHistoryList () {
      const category = this.$route.params.category
      request('get', `/innovation/activity-weekly/bet-memos?userId=${this.userInfo.UserId}&category=${category}`)
        .then(historyList => {
          this.historyList = historyList
          this.hasLoadAll = true
        })
    },
    onJoinNow () {
      const that = this
      const url = '/innovation/activity-weekly/join-now'
      const data = {
        UserUniqueId: this.userInfo.UserId || '',
        Category: this.$route.params.category
      }
      request('post', url, data).then(res => {
        if (res) {
          that.getHistoryList()
        }
      })
    },
    onPlay () {
      const category = this.$route.params.category
      this.$router.push(`/Home?category=${category}`)
    }
  }
}

</script>

<style lang="less" scoped>
  .betActivityWeeklyPage {
    padding-top: 50px;
    max-height: calc(100vh - 78px);
    overflow-y: scroll;

    .nav-wrapper {
      display: flex;
      flex-direction: column;

      .top-image {
        margin: 10px 2px 15px;
        max-height: 145px;
        object-fit: contain;
      }

      .nav {
        display: flex;
        margin: 24px 10px 20px 10px;
        border-radius: 6px;
        border: 1px solid rgba(246, 217, 170, 0.5);

        .nav-item {
          flex: 1;
          line-height: 30px;
          text-align: center;
        }

        .active {
          background: #F6D9AA;
          color: #543200;
          border-radius: 6px;
        }
      }
    }

    .cashReward {
      .row {
        display: flex;
        line-height: 22px;
        margin: 20px 5px;
        color: #FFFFFF;
        background: #433709;
        padding: 2px 14px;
        border-radius: 14px;
        font-size: 14px;
        font-weight: 400;

        .title {
          span {
            font-size: 12px;
          }
        }

        .vertical-bar {
          margin: 0 10px;
          color: #F2DAAD;
        }
      }

      .estimated {
        font-weight: 600;
      }

      .play-btn{
        background: #F6D9AA;
        border-radius: 6px;
        line-height: 20px;
        padding: 12px 0px;
        text-align: center;
        color: #000D2E;
        font-size: 20px;
        margin: 90px 10px 30px 10px;
      }
    }

    .historyList {
      height: 52vh;
      overflow: scroll;
    }
    @media (max-width: 380px) {
      .historyList {
        height: 44vh;
        overflow: scroll;
      }
    }

    .no-data-available {
      line-height: 100px;
      text-align: center;
    }

    .history-item {
      margin: 5px 10px;
      display: flex;
      line-height: 25px;

      .history-content {
        background: rgba(237, 185, 5, 0.2);
        margin: 0 0 0 20px;
        width: calc(100vw - 20px - 25px - 20px);
        border-radius: 52px;
        display: flex;

        .date {
          width: 25vw;
          padding: 0 15px;
          color: #FFFFFF;
          font-size: 14px;
          word-break:keep-all;
          white-space:nowrap;
          overflow:hidden;
          text-overflow:ellipsis;
          text-align: center;

          span {
            width: 100%;
          }
        }

        .betting-amount {
          width: 40vw;
          text-align: center;
          color: #FFFFFF;
          font-size: 14px;
          display: flex;

          span {
            width: 100%;
          }
        }

        .reward {
          width: 20vw;
          text-align: center;
          color: #FFFFFF;
          font-size: 14px;
          display: flex;

          span {
            width: 100%;
          }
        }

        .splitter {
          width: 1px;
          border-right: 1px solid #F6D9AA;
          margin: 3px 0px;
        }
      }
    }

    .splitter {
      margin: 15px 10px 15px 10px;
      border-bottom: 1px solid #FFFFFF;
    }

    .rules{
      margin: 0px 10px 80px 10px;
      padding-bottom: 100px;
      height: 62.8vh;
      overflow: scroll;
    }
    @media (max-width: 380px) {
      .rules {
        height: 57.6vh;
        overflow: scroll;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/BetActivityWeekly/index.vue